export const InsyncI18N = {
  PageTitle: {
    mainTitle: 'Great Minds Digital',
    assesmentDefaultTitle: 'Resources for {{subject}} | Great Minds Digital'
  },
  Events: {
    click: 'Click',
    cancel: 'Cancel',
    confirm: 'Confirm',
    cancelARIA: 'cancel uploads',
    confirmARIA: 'confirm'
  },
  Home: {
    title: 'InSync App',
    greeting: 'Welcome'
  },
  Avatar: {
    username: 'User: {{name}}'
  },
  ProfileButton: {
    label: 'View profile and more'
  },
  Popover: {
    defaultMessage: 'Please provide some text or jsx element, in order to render something.'
  },
  AppHeader: {
    appsNavigator: 'Apps Navigator'
  },
  Navigation: {
    returnPage: 'back to find'
  },
  ToggleLanguage: {
    es: 'Spanish',
    en: 'English',
    ariaLabelButton: '{{selectedOption}}, selected, {{selectedOptionCount}} of {{optionsLength}} radio button',
    language: 'Language',
    chooseALanguage: 'Choose a language:'
  },
  PreviewButton: 'Preview',
  DownloadButton: 'Download resource',
  ShareButton: 'Copy Link To Share',
  ShareTooltip: 'Copied!',
  DownloadAssignmentText: `Download the files needed to
  complete this assignment.`,
  UploadAssignmentText: `Upload your completed work to
  turn in this assignment.`,
  UploadButton: 'Upload',
  AttachmentList: {
    title: 'Attachments'
  },
  ResourceRow: {
    nav: 'Nav to'
  },
  ResourceDetail: {
    indicator: 'This resource has been assigned to you. Make sure you mark it as done.',
    buttonMessage: 'Go to assignment'
  },
  ResourceFullscreen: 'Enter fullscreen',
  ResourceExitFullscreen: 'Exit fullscreen',
  Assignment: {
    assignedOn: 'Assigned on',
    done: 'Done',
    doneARIA: 'done uploading',
    dueDateOn: 'Due date on',
    for: 'for ',
    instructions: 'Instructions',
    uploadYourWork: 'Upload your work',
    downloadFiles: 'Download files',
    toggleInstructions: {
      show: 'Show Instructions',
      hide: 'Hide Instructions',
      showARIA: 'Show Instructions',
      hideARIA: 'Hide Instructions'
    },
    confirmationModal: {
      title: 'Are you sure you are finished?',
      description: 'Select “yes” to send your completed assignment to your teacher.',
      confirm: 'YES',
      cancel: 'NO'
    },
    doneModal: {
      text: 'Good work, as always.',
      button: 'Return to home'
    },
    errorMessage: {
      closedDeletedAssignment: 'Sorry, the teacher has deleted/closed this assignment and it’s no longer available.',
      closedAssignment: 'Sorry, the teacher has closed this assignment and it’s no longer available.',
      deletedAssignment: 'Sorry, the teacher has deleted this assignment and it’s no longer available.',
      genericError: 'An error has occurred, please try again.',
      doneError: 'Sorry the assignment could not be marked as DONE. Please try again or contact your administrator.',
      sessionError: `We're sorry, your session timed out and we could not save your latest changes. Please log back in to continue working on this assignment.`
    }
  },
  FileUploader: {
    fileDetails: 'You can add images, slides, and pdf files less than 100 MB',
    dragableZone: 'Drag and drop your files here or',
    browseOption: 'Browse',
    browseOptionARIA: 'browse your files to upload',
    buttonShowFileExtensions: 'Show me supported files',
    buttonShowFileExtensionsARIA: 'Show me supported files',
    filesExtensionAccepted: '(.doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .pdf, .odt, .ods, .odp) and Images (.jpg, .jpeg, .bmp, .gif, .png)'
  },
  ModalCard: {
    closeModal: 'Close modal card.'
  },
  FileList: {
    failedUpload: 'File could not be uploaded. Try again',
    failedUploadSize: 'File size is too large',
    failedUploadType: 'The file format is not valid',
    successfulUpload: 'Uploaded',
    removeFile: 'Remove',
    uploading: 'Uploading...',
    ariaLabelRemoveFile: ' {{fileName}} uploaded, remove'
  },
  Redirect: {
    goToTodo: 'Return to Home.'
  },
  Dates: {
    today: 'Today'
  },
  Months: {
    january: {
      short: 'Jan'
    },
    february: {
      short: 'Feb'
    },
    march: {
      short: 'Mar'
    },
    april: {
      short: 'Apr'
    },
    may: {
      short: 'May'
    },
    june: {
      short: 'June'
    },
    july: {
      short: 'July'
    },
    august: {
      short: 'Aug'
    },
    september: {
      short: 'Sept'
    },
    october: {
      short: 'Oct'
    },
    november: {
      short: 'Nov'
    },
    december: {
      short: 'Dec'
    }
  },
  LoadLibrary: {
    EmptyLibraryMessage: 'We’re sorry, you do not have access to these resources. When your teacher has assigned you content, you will see it on your To Do page.'
  },
  GradeFilter: {
    findResource: 'Select a grade to find resources'
  }
};
export const AppBundleEn = {
  language: 'en',
  namespace: 'insync-app',
  resources: InsyncI18N
};
export default AppBundleEn;